import { useCallback, useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./Kyc.module.css";
import { useNavigate } from "react-router";
import axios from "axios";
import { observer } from "mobx-react";
import config from "../../config/config";
import store from "../../Store/Store";
import { Pagination } from "antd";
import NewUsers from "../Users/newUsers/NewUsers";
import KycStatus from "./Kyc_Status/KycStatus";
import Notificatio from "../Users/Notification/Notificatio";
import KycResend from "../Users/KycResend/KycResend";

const Kyc = observer(({ className = "" }) => {
  const [flag, setFlag] = useState(false);
  const [flagNotifi, setFlagNotifi] = useState(false);
  const [data, setData] = useState([]);
  const [serchFilter, setSerchFilter] = useState("");
  const [companyname, setcompanyname] = useState("");
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [refresh, setRefresh] = useState(true);
  const [Kyctype, SetKycType] = useState("pending");
  const [newFlag, setNewFlag] = useState(false);
  const [allData, setAllData] = useState([]);
  const [ResendReq, setResendReq] = useState(false);

  const onAddNewUsersClick = useCallback(() => {
    setFlag(true);
  }, []);
  useEffect(() => {
    let auth = localStorage.getItem("authToken");
    if (!auth) {
      navigate("/login");
      return;
    }
    GetkycStatus("pending");
  }, []); //flagNotifi, refresh, store.refresh

  const GetkycStatus = (status) => {
    const obj = {
      ledger_label: store.Company_Id,
      status: status,
    };

    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);

    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/pine/get_users_kyc`,
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: obj,
    };
    console.log("objjjjjj---->", obj);

    axios
      .request(payload)
      .then((res) => {
        if (Array.isArray(res.data.data)) {
          console.log("res.data", res.data);

          setData(res.data.data);
          setAllData(res.data.data);
        } else {
          console.warn("Unexpected response format:", res.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching KYC status:", err.message);
        // Optionally show a UI error message (e.g., "Failed to fetch KYC status")
      });
  };

  const filteredData = data.filter(
    (user) =>
      user?.user_name?.toLowerCase()?.includes(serchFilter?.toLowerCase()) ||
      user?.user_email?.toLowerCase()?.includes(serchFilter?.toLowerCase()) ||
      user?.user_mobile_no?.includes(serchFilter)
  );

  useEffect(()=>{
    if(store.Company_Id!="EStackPine"){
      navigate("/")
    }
  },[store.Company_Id])
  const startIndex = (currentPage - 1) * pageSize;
  let currentPageData = filteredData
    .reverse()
    .slice(startIndex, startIndex + pageSize);

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };
  return (
    <div className={styles.pageContainer + " " + className}>
      <div className={styles.frameParent}>
        <div className={styles.welcomesunshineinfotechWrapper}>
          <div className={styles.welcomesunshineinfotech}></div>

          <button className={styles.addNewUsers} onClick={onAddNewUsersClick}>
            <img
              className={styles.plusCircleIcon}
              alt=""
              src="/pluscircle.svg"
            />
            <b className={styles.newUser}>New KYC Request</b>
          </button>
        </div>
        <div className={styles.frameGroup}>
          <div className={styles.filterContainer}>
            <div
              className={
                Kyctype == "pending"
                  ? styles.filterContainerItemsActive
                  : styles.filterContainerItems
              }
              onClick={() => {
                SetKycType("pending");
                GetkycStatus("pending");
                setData([]);
                setAllData([]);
              }}
            >
              Pending
            </div>
            <div className={styles.filterContainerBlocks}></div>
            <div
              className={
                Kyctype == "Expired"
                  ? styles.filterContainerItemsActive
                  : styles.filterContainerItems
              }
              onClick={() => {
                SetKycType("Expired");
                GetkycStatus("Expired");

                setData([]);
                setAllData([]);
              }}
            >
              Expired
            </div>
            <div className={styles.filterContainerBlocks}></div>
            <div
              className={
                Kyctype == "Rejected"
                  ? styles.filterContainerItemsActive
                  : styles.filterContainerItems
              }
              onClick={() => {
                SetKycType("Rejected");
                GetkycStatus("Rejected");
                setData([]);
                setAllData([]);
              }}
            >
              Rejected
            </div>
          </div>
          <div className={styles.feeStatementDataTable}>
            <div className={styles.top}>
              <div className={styles.filterWrapper}>
                <div className={styles.filter}>
                  {Kyctype == "pending" ? (
                    <div className={styles.containertext}>Pending KYC List</div>
                  ) : Kyctype == "Expired" ? (
                    <div className={styles.containertext}>Expired KYC List</div>
                  ) : (
                    <div className={styles.containertext}>
                      Rejected KYC List
                    </div>
                  )}
                </div>
                <div className={styles.filter}>
                  <div className={styles.textField}>
                    <div className={styles.content}>
                      <img
                        className={styles.leadingIcon}
                        alt=""
                        src="/leadingicon.svg"
                      />
                      <input
                        className={styles.labelText1}
                        placeholder="Search..."
                        type="text"
                        value={serchFilter}
                        onChange={(e) => {
                          setSerchFilter(e.target.value);
                        }}
                      />
                    </div>
                  </div>

                  <button
                    className={styles.reLoadTable}
                    onClick={() => {
                     GetkycStatus(Kyctype);
                    }}
                  >
                    <img
                      className={styles.vectorIcon1}
                      alt=""
                      src="/vector7.svg"
                    />
                  </button>
                </div>
              </div>
            </div>
            <table className={styles.table}>
              <thead className={styles.tableHead}>
                <tr className={styles.tableHeaderRow}>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>Created date</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>Name</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>Email</div>
                  </th>

                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>Phone no </div>
                  </th>

                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>KYC Status</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>Action</div>
                  </th>
                </tr>
              </thead>
              <tbody className={styles.tableHead}>
                {currentPageData.map((detail, index) => (
                  <tr key={index} className={styles.tableBodyrow}>
                    <td className={styles.tableBodydata}>
                      {" "}
                      <div className={styles.data1}>
                        {detail.kyc_initiate_on}
                      </div>
                    </td>
                    <td className={styles.tableBodydata}>
                      {" "}
                      <div className={styles.data1}>{detail.user_name}</div>
                    </td>
                    <td className={styles.tableBodydata}>
                      {" "}
                      <div className={styles.data1}>{detail.user_email}</div>
                    </td>
                    <td className={styles.tableBodydata}>
                      {" "}
                      <div className={styles.data}>{detail.user_mobile_no}</div>
                    </td>
                    <td className={styles.tableBodydata}>
                      <div className={styles.data}> {Kyctype.toUpperCase()} </div>
                    </td>
                    <td className={styles.tableBodydata}>
                      <button className={styles.button}>
                        <img
                          alt=""
                          src="/eye.svg"
                          className={styles.btn_img}
                          onClick={() => {
                            store.setName(detail.user_name); //
                            store.setSelectedEmail(detail.user_email); //
                            store.setKycStatus(Kyctype); //
                            store.setCreate_at(detail.kyc_initiate_on); //
                            store.setPhoneNo(detail.user_mobile_no); //

                            store.setKycRejectedReason(detail.reason); //**
                            store.setTxnLimit(detail.per_transaction_limit); 
                            store.setDailyLimit(detail.dailty_limit); 
                            store.setmonthlyLimit(detail.monthly_limit); 
                            store.setTags(detail.tags); 
                            setNewFlag(true);
                          }}
                        />
                        {Kyctype != "pending" && (
                          <div className={styles.btn_text1}>/</div>
                        )}
                        {Kyctype != "pending" && (
                          <div
                            className={styles.btn_text}
                            onClick={() => {
                              setResendReq(true);
                            }}
                          >
                            Re-send
                          </div>
                        )}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className={styles.bottom}>
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={filteredData.length}
                onChange={handlePaginationChange}
                // showSizeChanger
              />
            </div>
          </div>
        </div>
      </div>
      {flag && (
        <div
          className={styles.newUsersOverlay}
          onClick={() => {
            setFlag(false);
          }}
        >
          <NewUsers
            isVisible={flag}
            onClose={() => setFlag(false)}
            setAdmin={() => {
              // setIsAdmin(true);
            }}
            openNoti={() => {
              setFlagNotifi(true);
            }}
          />
        </div>
      )}
      {newFlag && (
        <div
          className={styles.newUsersOverlay}
          onClick={() => {
            setNewFlag(false);
          }}
        >
          <KycStatus isVisible={newFlag} onClose={() => setNewFlag(false)} />
        </div>
      )}

      {flagNotifi && (
        <div
          className={styles.newUsersOverlay1}
          onClick={() => {
            setFlagNotifi(false);
            store.setInitiateKYC("")
          }}
        >
          <Notificatio
            isVisible={flagNotifi}
            onClose={() => {
              setFlagNotifi(false);
              store.setInitiateKYC("")
            }}
          />
        </div>
      )}
      {ResendReq && (
        <div
          className={styles.newUsersOverlay1}
          onClick={() => {
            setResendReq(false);
          }}
        >
          <KycResend
            isVisible={ResendReq}
            onClose={() => {
              setResendReq(false);
            }}
          />
        </div>
      )}
    </div>
  );
});

Kyc.propTypes = {
  className: PropTypes.string,
};

export default Kyc;
